import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, IconButton, Tooltip, useTheme } from "@mui/material";
import { CurrencyExchange } from "@mui/icons-material";

const RelatedPrestacionesGrid = ({ rows, onRefacturar }) => {
  const theme = useTheme();

  const columns = [
    {
      field: "fecha",
      headerName: "Fecha",
      flex: 1.5,
    },
    {
      field: "odontologo",
      headerName: "Odontólogo",
      flex: 1.2,
      renderCell: (params) => {
        const nombre = params.value?.toLowerCase() ?? "";
        const capitalized = nombre
          .split(" ")
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(" ");

        return capitalized;
      },
    },
    {
      field: "codigo",
      headerName: "Código",
      flex: 1.2,
    },
    {
      field: "diente",
      headerName: "Dte",
      flex: 0.5,
    },
    {
      field: "periodo_refacturacion",
      headerName: "Refact.",
      flex: 0.5,
    },
    {
      field: "auditoria",
      headerName: "Auditoria",
      flex: 1,
    },
    {
      field: "acciones",
      headerName: "",
      width: 60,
      sortable: false,
      renderCell: (params) => (
        <Tooltip title="Refacturar">
          <IconButton
            size="small"
            color="primary"
            onClick={() => onRefacturar?.(params.row)}
          >
            <CurrencyExchange fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  return (
    <Box
      sx={{
        height: Math.min(48 * rows.length + 56, 200),
        width: "100%",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 1,
        bgcolor: theme.palette.background.paper,
        boxShadow: 1,
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        hideFooter
        disableColumnMenu
        disableRowSelectionOnClick
        getRowId={(row) => row.id}
        rowHeight={42}
        headerHeight={40}
        density="compact"
        sx={{
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.grey[100],
            fontWeight: 600,
          },
          "& .MuiDataGrid-cell": {
            borderBottom: `1px solid ${theme.palette.divider}`,
          },
          "& .MuiDataGrid-row:nth-of-type(odd)": {
            backgroundColor: "#f0f4f8", // Gris azulado suave
          },
          "& .MuiDataGrid-row:nth-of-type(even)": {
            backgroundColor: "#f9f9f9", // Gris muy claro
          },
          "& .capitalizeCell": {
            textTransform: "capitalize",
          },
        }}
      />
    </Box>
  );
};

export default RelatedPrestacionesGrid;
